import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Box } from '@mui/material';
import RoofingIcon from '@mui/icons-material/Roofing';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type RoofingDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const RoofingDetails = ({ control }: RoofingDetailsProps) => {
  const { errors } = useFormState({ control });

  const { envelope } = useWatch({ control });
  const roofingTypes = envelope?.roofingTypes;

  const attachmentCount = roofingTypes?.attachments?.length ?? 0;

  const items = [
    {
      label: 'Types',
      value: roofingTypes?.types,
      error: !!errors.envelope?.roofingTypes?.types,
    },
    {
      label: 'Attachments',
      value: attachmentCount > 0 ? String(attachmentCount) : undefined,
      error: false,
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <RoofingIcon fontSize="inherit" />
            <span>&nbsp;Roofing types</span>
          </Grid>
        </Typography>
        {items.map(({ label, value, error }) => (
          <Grid key={label} container justifyContent="space-between">
            <Typography component="span" variant="body2">
              {label}:
            </Typography>
            <Typography
              component="span"
              variant="body2"
              color={
                error ? 'error' : isNil(value) ? 'textDisabled' : 'textPrimary'
              }>
              {isNil(value) ? '—' : value}
            </Typography>
          </Grid>
        ))}
      </Stack>
    </Box>
  );
};
